import React, { useEffect, useMemo } from 'react'
import { CheckboxSelector, Avatar, CheckboxSelectorInner } from '@Knowledge-OTP/znk-ui-components'
import useTranslation from '../../../i18n/useTranslation'
import { gql, useLazyQuery } from '@apollo/client'
import FilterBadge from '../../../common/FilterBadge'

const ParentsFilter = (props) => {
  const { translate } = useTranslation()
  const { parentFilters, setParentFilters, loading = false, useInner = false } = props

  const [getParents, { data: dataParent, loading: loadingParent }] = useLazyQuery(
    gql`query($roles: [Roles!], $search: String, $limit: Int) {
        allUsers(roles: $roles, search: $search, limit: $limit) {
            hasNext
            hasPrevious
            next
            previous
            totalDocs
            docs {
                id
                firstName
                lastName
            }
        }
    }
    `,
    {
      variables: { limit: 0, roles: ['PARENT'], search: '' }
    }
  )

  useEffect(
    () => {
      getParents()
    }, [getParents]
  )
  const students = useMemo(() => {
    return dataParent?.allUsers?.docs || []
  }, [dataParent])

  const parentOptions = students.map(user => ({
    name: `${user.firstName} ${user.lastName}`,
    id: user.id,
    Component: (
      <Avatar
        name={`${user.firstName} ${user.lastName}`}
        named={false}
        uri={null}
        size='avatar-small'
      />
    )
  })).sort((a, b) => a.name.localeCompare(b.name))

  const checkboxSelectorProps = {
    setDataFilters: setParentFilters,
    direction: 'bottomRight',
    dataFilters: parentFilters,
    loading: loadingParent || loading,
    data: parentOptions,
    typeFilter: 'users',
    strings: {
      viewAll: translate('filters.plans.viewAll'),
      buttonCancel: translate('filters.plans.buttonCancel'),
      buttonApply: translate('filters.plans.buttonApply'),
      search: translate('filters.plans.search')
    }
  }

  return useInner ? (
    <CheckboxSelectorInner
      style={{ maxWidth: 'auto' }}
      {...checkboxSelectorProps}
    />
  ) : (
    <CheckboxSelector {...checkboxSelectorProps}>
      <FilterBadge
        title={translate('filters.payments.parentTitle')}
        options={parentOptions}
        selectedIds={parentFilters}
        onClearFilters={() => setParentFilters([])}
      />
    </CheckboxSelector>
  )
}
export default ParentsFilter
